import { SELECT_LOOKUP, HIDDEN, NUMBER_FIELD, DATE } from '../InputTypes';

export const fields = [
  'ObjectTypeName',
  'Pieces',
  'ObjectNumber',
  'Amount',
  'Begda',
  'Endda',
];

export const detailFields = [
  ...fields,
];

export const entityMap = {
  EmployeeMasterID: {
    type: HIDDEN,
  },
  ObjectType: {
    type: SELECT_LOOKUP,
    lookup: {
      entity: 'HrObjectType',
      value: 'HrObjectTypeID',
      label: 'HrObjectTypeName',
    },
  },
  Pieces: {
    type: NUMBER_FIELD,
  },
  ObjectNumber: {
    type: NUMBER_FIELD,
  },
  Amount: {
    type: NUMBER_FIELD,
  },
  Begda: {
    type: DATE,
  },
  Endda: {
    type: DATE,
  },
};



// WEBPACK FOOTER //
// ./src/constants/fields/EmployeeMasterObjectOnLoan.js